/**
 * Vaadin 25 Lumo theme for standalone Lit/webpack app.
 * JS Lumo modules were removed in V25; load the CSS bundle explicitly.
 */
import {registerStyles, css} from '@vaadin/vaadin-themable-mixin/register-styles.js';
import '@vaadin/vaadin-lumo-styles/lumo.css';
import '@vaadin/vaadin-lumo-styles/icons.js';
import './vaadin-lumo-overrides.css';

/**
 * Vaadin 24.3+ sets header cell font-size smaller than body cells. Column widths
 * defined in em then resolve differently in header vs body, misaligning columns.
 */
registerStyles(
	'vaadin-grid',
	css`
		.header-cell,
		.footer-cell {
			font-size: var(--lumo-font-size-m);
		}

		#scroller:not([range-selecting], [column-resizing]) .body-cell,
		#scroller:not([range-selecting], [column-resizing]) .body-cell ::slotted(vaadin-grid-cell-content) {
			-webkit-user-select: text;
			user-select: text;
		}
	`,
	{moduleId: 'driveline-grid-column-alignment'}
);
